<div class="manage-colors-container">

  @if (viewMode() === 'list') {
    <div class="header-actions">
      <h2>Gestión de Colores</h2>
      <button class="btn-primary" (click)="openNewForm()">+ Nuevo Color</button>
    </div>

    @if (isLoading()) {
      <p>Cargando colores...</p>
    } @else {
      <table class="admin-table">
        <thead>
          <tr>
            <th>Color</th>
            <th>Nombre</th>
            <th>Nombre interno</th>
            <th>Stock</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          @for (color of colors(); track color.id) {
            <tr>
              <td>
                <div class="color-swatch" [ngStyle]="getSwatchStyle(color)"></div>
              </td>
              <td class="fw-bold">{{ color.name }}</td>
              <td class="color-label">{{ color.label ?? '—' }}</td>
              <td>
                <span class="status-badge" [class.active]="color.isAvailable">
                  {{ color.isAvailable ? 'Con stock' : 'Sin stock' }}
                </span>
              </td>
              <td>
                <div class="action-buttons">
                  <button class="btn-icon edit" (click)="openEditForm(color)">Editar</button>
                  <button class="btn-icon delete" (click)="deleteColor(color)">Borrar</button>
                </div>
              </td>
            </tr>
          }
          @if (colors().length === 0) {
            <tr>
              <td colspan="5" class="text-center">No hay colores registrados.</td>
            </tr>
          }
        </tbody>
      </table>
    }
  }

  @else {
    <div class="header-actions">
      <h2>{{ editingColorId ? 'Editar Color' : 'Nuevo Color' }}</h2>
      <button class="btn-outline" (click)="closeForm()">Volver a la lista</button>
    </div>

    <form [formGroup]="colorForm" (ngSubmit)="onSubmit()" class="color-form">

      <div class="form-group">
        <label>Nombre de color (público) *</label>
        <input type="text" formControlName="name" placeholder="Ej: Azul marino">
        @if (colorForm.get('name')?.invalid && colorForm.get('name')?.touched) {
          <span class="error-msg">El nombre es requerido y máximo 50 caracteres.</span>
        }
      </div>

      <div class="form-group">
        <label>Nombre de color (interno)</label>
        <input type="text" formControlName="internalName" placeholder="Ej: Azul rey SKU 10283727">
      </div>

      <div class="form-group row-group">
        <div class="palette-section">
          <label>Paleta de color</label>
          <div class="palette-list" formArrayName="hexCodes">
            @for (control of hexCodesArray.controls; track control; let i = $index) {
              <div class="color-picker-row">
                <div class="color-input-wrapper">
                  <input type="color" [formControlName]="i">
                </div>
                <span class="hex-display">RGB</span>
                @if (hexCodesArray.length > 1) {
                  <button type="button" class="btn-remove-color" (click)="removeHexCode(i)" aria-label="Eliminar color">✕</button>
                }
              </div>
            }
          </div>
          @if (hexCodesArray.length < 3) {
            <button type="button" class="btn-add-color" (click)="addHexCode()">+ Agregar</button>
          }
        </div>

        <div class="stock-section">
          <label>Stock de filamento</label>
          <div class="toggle-wrapper">
            <input type="checkbox" formControlName="isAvailable" id="availableStatus">
            <label for="availableStatus">
              {{ colorForm.get('isAvailable')?.value ? 'Con stock' : 'Sin stock' }}
            </label>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button type="button" class="btn-outline" (click)="closeForm()">Cancelar</button>
        <button type="submit" class="btn-primary" [disabled]="isSubmitting() || colorForm.invalid || !hasFormChanged">
          {{ isSubmitting() ? 'Guardando...' : 'Guardar color' }}
        </button>
      </div>

    </form>
  }

</div>
